(function () {
  const timeZone = 'America/New_York';
  const cutoffDay = 1;
  const weekMs = 7 * 24 * 60 * 60 * 1000;

  function easternDateParts(date) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(date);

    return parts.reduce((memo, part) => {
      if (part.type !== 'literal') memo[part.type] = part.value;
      return memo;
    }, {});
  }

  function weekdayIndex(shortWeekday) {
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(shortWeekday);
  }

  function updateCutoffProgress(status) {
    const parts = easternDateParts(new Date());
    const currentDay = weekdayIndex(parts.weekday);
    const nowMs = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );

    let daysUntilCutoff = (cutoffDay - currentDay + 7) % 7;
    let cutoffMs = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day) + daysUntilCutoff,
      23,
      59,
      0
    );

    if (nowMs > cutoffMs) {
      cutoffMs += weekMs;
      daysUntilCutoff += 7;
    }

    const previousCutoffMs = cutoffMs - weekMs;
    const progress = Math.max(0, Math.min(1, (nowMs - previousCutoffMs) / weekMs));

    status.style.setProperty('--coffee-cutoff-progress', `${progress * 100}%`);
  }

  function initCutoffProgress() {
    document.querySelectorAll('[data-coffee-cutoff-progress]').forEach((status) => {
      updateCutoffProgress(status);
      window.setInterval(() => updateCutoffProgress(status), 60 * 1000);
    });
  }

  function initThumbnailRails() {
    document.querySelectorAll('.coffee-product__media').forEach((media) => {
      const stage = media.querySelector('.coffee-product__stage');
      const stageTrack = stage?.querySelector('.splide__track');
      const track = media.querySelector('.coffee-product__thumbs .splide__track');
      if (!stageTrack || !track) return;

      let queued = false;
      let heightQueued = false;

      const setRailHeight = () => {
        heightQueued = false;
        const activeMedia = stageTrack.querySelector('.splide__slide.is-active [data-product-single-media-wrapper]')
          || stageTrack.querySelector('[data-product-single-media-wrapper]');
        const height = (activeMedia || stageTrack).getBoundingClientRect().height;
        if (height > 0) {
          media.style.setProperty('--coffee-media-height', `${height}px`);
        }
      };

      const queueHeight = () => {
        if (heightQueued) return;
        heightQueued = true;
        window.requestAnimationFrame(setRailHeight);
      };

      const scrollActiveThumbIntoView = () => {
        queued = false;
        const activeThumb = track.querySelector('.coffee-product__thumb.is-active');
        if (!activeThumb) return;

        activeThumb.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: 'smooth',
        });
      };

      const queueScroll = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(scrollActiveThumbIntoView);
      };

      const observer = new MutationObserver(() => {
        queueScroll();
        queueHeight();
      });
      observer.observe(track, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(queueHeight);
        resizeObserver.observe(stageTrack);
      }

      stageTrack.querySelectorAll('img, video, model-viewer').forEach((element) => {
        element.addEventListener('load', queueHeight, { once: true });
        element.addEventListener('loadedmetadata', queueHeight, { once: true });
      });

      track.addEventListener('click', queueScroll);
      window.addEventListener('resize', queueHeight, { passive: true });
      queueHeight();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCutoffProgress();
      initThumbnailRails();
    });
  } else {
    initCutoffProgress();
    initThumbnailRails();
  }
})();
